import { Yup } from 'cng-web-lib'

function makeValidationSchema() {

  return Yup.object({
    partyId: Yup.number(),
  })
}

export default makeValidationSchema
